import { Route, Routes } from "react-router-dom";
import NotFound from "../Layouts/NotFound";
import OperatorLogin from "../OperatorPortal/Auth/Login";
import ForgetPassword from "../Pages/Auth/ForgetPassword";
import Login from "../Pages/Auth/Login";
import ResetPassword from "../Pages/Auth/ResetPassword";

const PublicRoutes = (props) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Login setUser={props.setUser} setIsLogged={props.setIsLogged} setUserPermissions={props.setUserPermissions} />
        }
      />
      <Route
        path="/login"
        element={
          <Login setUser={props.setUser} setIsLogged={props.setIsLogged} setUserPermissions={props.setUserPermissions}/>
        }
      />

      <Route path="/forgetpassword" element={<ForgetPassword />} />
      <Route
        path="/ResetPassword/:UserId/:TempPassword"
        element={<ResetPassword />}
      />
      <Route path="*" element={<Login setUser={props.setUser} setIsLogged={props.setIsLogged} setUserPermissions={props.setUserPermissions} />} />
    </Routes>
  );
};

export default PublicRoutes;
